<script setup lang="ts">
import { PropType, ref, watch } from "vue";
import Datepicker from "@vuepic/vue-datepicker";
import { useI18n } from "vue-i18n";

export type ChartPeriod = {
  type: "lastDay" | "lastWeek" | "lastMonth" | "custom";
  dateRange?: [Date, Date];
};

const props = defineProps({
  period: { type: Object as PropType<ChartPeriod>, required: true },
});
const emit = defineEmits<{ (e: "change", period: ChartPeriod): void }>();

const dateRange = ref<[Date, Date]>();

const isMobile = () => window.innerWidth <= 760;

watch(
  () => props.period,
  () => {
    dateRange.value = props.period?.dateRange;
  }
);

const i18n = useI18n();
</script>
<template>
  <div class="flex text-xs items-center flex-wrap gap-y-1.5 justify-end">
    <div
      v-for="p in [
        ['lastDay', 'ChartLastDay'],
        ['lastWeek', 'ChartLastWeek'],
        ['lastMonth', 'ChartLastMonth'],
      ] as const"
      :key="p[0]"
      @click="emit('change', { type: p[0] })"
      class="ml-1.5 py-1 px-3 rounded-3xl cursor-pointer"
      :class="period.type === p[0] ? 'bg-midblue' : 'bg-gray-500'"
    >
      {{ $t(p[1]) }}
    </div>

    <Datepicker
      v-model="dateRange"
      range
      :teleport-center="isMobile()"
      @update:modelValue="
        emit('change', { type: 'custom', dateRange: dateRange })
      "
      :locale="i18n.locale.value"
      :select-text="$t('Save')"
      :cancel-text="$t('Back')"
      :dark="true"
    >
      <template #trigger>
        <div
          :class="period.type === 'custom' ? 'bg-midblue' : 'bg-gray-500'"
          class="ml-1.5 py-1 px-3 rounded-3xl cursor-pointer"
        >
          {{ $t("ChartCustomPeriod") }}
        </div>
      </template>
    </Datepicker>
  </div>
</template>
